<template lang="pug">
.content-wrap
	.content-top
		.con
			.vip-wrapper(v-if="!loading")
				.vipinfo.pb-5(:class="{'epic-vip' : turnoverDetails[0].vip_next === null}")
					.iimg
						img(:src="'/new/img/vip/'+turnoverDetails[0].vip_id+'.png'")
						span {{ turnoverDetails[0].vip_name }}
						//- small -
					.ccon
						//- .t {{accountID}}
						.m
							template(v-if="turnoverDetails[0].vip_next !== null")
								.lwrap
									.levelbar(v-if="showDepo")
										.levmsg Deposit : 
											span {{ $numeral(totalDeposit).format("0,0.00") }}
											| / {{ $numeral(turnoverDetails[0].deposit_next).format("0,0.00") }}
										.levbar
											span(:style="'width:'+depoProgress+'%'")
									.levelbar(v-if="showTo")
										.levmsg Turnover : 
											span {{ $numeral(totalTurnover).format("0,0.00") }}
											| / {{ $numeral(turnoverDetails[0].turnover_next).format("0,0.00") }}
										.levbar
											span(:style="'width:'+toProgress+'%'")
								.lnext
									i Next Level
									img(:src="'/new/img/vip/'+turnoverDetails[0].vip_next+'.png'")
									span {{ turnoverDetails[0].vip_name_next }}
				.af-tab
					.af-tabc.aaa
						a(href="javascript:void(0)")
							img(src='/new/img/af/icon-depo.png')
							|  {{$t('ui.deposit')}}
					| |
					.af-tabc
						router-link(to='withdrawal')
							img(src='/new/img/af/icon-with.png')
							|  {{$t('ui.withdrawal')}}
				.af-box(v-if="!startRender")
					.form-box.mb-3.mt-3
						.wallet.payment
							template(v-for="gateway in bankModeList")
								.w-menu(v-if="gateway.payment_mode === 'gcash'" @click="changeTab(0)" :class="{'active' : selectedTab === 0}")
									img(src="/new/img/af/bank/gcash.png")
									span {{gateway.payment_desc}}
								.w-menu(v-if="gateway.payment_mode === 'gcashqr'" @click="changeTab(1)" :class="{'active' : selectedTab === 1}")
									img(src="/new/img/af/bank/gcashqr.png")
									span {{gateway.payment_desc}}
								.w-menu(v-if="gateway.payment_mode === 'maya'" @click="changeTab(2)" :class="{'active' : selectedTab === 2}")
									img(src="/new/img/af/bank/maya.png")
									span {{gateway.payment_desc}}
								.w-menu(v-if="gateway.payment_mode === 'grabpay'" @click="changeTab(3)" :class="{'active' : selectedTab === 3}")
									img(src="/new/img/af/bank/grab.png")
									span {{gateway.payment_desc}}
								.w-menu(v-if="gateway.payment_mode === 'usdt'" @click="changeTab(4)" :class="{'active' : selectedTab === 4}")
									img(src="/new/img/af/bank/usdt.png")
									span {{gateway.payment_desc}}
								.w-menu(v-if="gateway.payment_mode === 'bank'" @click="changeTab(5)" :class="{'active' : selectedTab === 5}")
									img(src="/new/img/af/bank/bank.png")
									span {{gateway.payment_desc}}
								.w-menu(v-if="gateway.payment_mode === 'qrph'" @click="changeTab(6)" :class="{'active' : selectedTab === 6}")
									img(src="/new/img/af/bank/qrph.png")
									span {{gateway.payment_desc}}
					gcash(v-if="selectedTab === 0" :minSettingDeposit="minDeposit" :operatorBankList="operatorBankList" :promotionList="promoList" :providerList="gcashChannel")
					gcashqr(v-if="selectedTab === 1" :minSettingDeposit="minDeposit" :operatorBankList="operatorBankList" :promotionList="promoList" :providerList="gcashqrChannel")
					maya(v-if="selectedTab === 2" :minSettingDeposit="minDeposit" :operatorBankList="operatorBankList" :promotionList="promoList" :providerList="mayaChannel")
					grab(v-if="selectedTab === 3" :minSettingDeposit="minDeposit" :operatorBankList="operatorBankList" :promotionList="promoList" :providerList="grabChannel")
					usdt(v-if="selectedTab === 4" :minSettingDeposit="minDeposit" :operatorBankList="operatorBankList" :promotionList="promoList" :providerList="usdtChannel")
					bank(v-if="selectedTab === 5" :minSettingDeposit="minDeposit" :operatorBankList="operatorBankList" :promotionList="promoList" :providerList="bankChannel")
					qrph(v-if="selectedTab === 6" :minSettingDeposit="minDeposit" :operatorBankList="operatorBankList" :promotionList="promoList" :providerList="qrphChannel")
				.af-box(v-else)
					.text-white.my-2.text-center
						i.fas.fa-duotone.fa-spinner.fa-spin-pulse.text-black
</template>
<script>
// import manualDeposit from '@/component/payment/_manualDeposit.vue'
import gcash from '@/component/payment/_gcash.vue'
import gcashqr from '@/component/payment/_gcashqr.vue'
import maya from '@/component/payment/_maya.vue'
import grab from '@/component/payment/_grabPay.vue'
import usdt from '@/component/payment/_usdt.vue'
import bank from '@/component/payment/_bank.vue'
import qrph from '@/component/payment/_qrph.vue'
export default {
	components:{
		// manualDeposit,
		gcash,
		gcashqr,
		maya,
		grab,
		usdt,
		bank,
		qrph
		// balance
	},
	data(){
		return{
			conditionChecked: false,
			loading: true,
			startRender: false,
      feedback: {
        success: true,
        status: ""
      },
			selectedTab: "",
			bankModeList: [],
			minDeposit: 0,
			// minWithdrawal: 0,
      promoList: [],
      operatorBankList: [],
			gcashChannel: [],
			gcashqrChannel: [],
			mayaChannel: [],
			grabChannel: [],
			usdtChannel:[],
			bankChannel: [],
			qrphChannel: [],
			slideState: 0,
			turnoverDetails: [],
			depoProgress: 0,
      toProgress: 0,
      totalDeposit: 0,
      totalTurnover: 0,
      showDepo: false,
      showTo: false,
		}
	},
	computed: {
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    }
  },
	watch:{
    sessionToken(newState, oldState){
      var vm = this
      if(newState === '' || newState === undefined){
        vm.$router.push("/").catch(err => {});
      }
    }
  },
	created(){
		if(this.$store.getters.isLoggedIn){
			this.getBankingMode();
		}
	},
	mounted(){
		$('link[rel="canonical"]').attr('href', `${window.location.protocol}//${window.location.hostname}/deposit`);
		window.scrollTo(0, 0)
		this.getMemberVip()
		var vm = this
		$('.payment-mode ul').on('afterChange', function(event, slick, currentSlide){
			vm.slideState = currentSlide
    });

	},
	methods:{
		// returnWidth(){
		// 	var size = this.bankModeList.length
		// 	switch(size){
		// 		case 1:
		// 			return "w-100"
		// 		case 2:
		// 			return "duo-display"
		// 		case 3:
		// 			return "trio-display"
		// 		case 4:
		// 			return "quad-display"
		// 		case 5:
		// 			return "pent-display"
		// 		case 6:
		// 			return "hex-display"
		// 		case 7: 
		// 			return "hepta-display"
		// 		default:
		// 			return "" 
		// 	}
		// },
		getMemberVip(){
      if (this.sessionToken) {
        this.loading = true
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/getMemberVip", { account_id, auth_token })
          .then(response => {
            if (response.success == true) {
              this.turnoverDetails = response.data.deposit_turnover
              this.chart = response.data.next_level
              this.totalDeposit = this.turnoverDetails[0].starting_deposit + this.turnoverDetails[0].cycle_deposit
              this.totalTurnover = this.turnoverDetails[0].starting_turnover + this.turnoverDetails[0].cycle_turnover
              this.depoProgress = ( this.totalDeposit / this.turnoverDetails[0].deposit_next) * 100
              this.toProgress = (this.totalTurnover / this.turnoverDetails[0].turnover_next) * 100
							if(this.depoProgress > 100){
								this.depoProgress = 100
							}
							if(this.toProgress > 100){
								this.toProgress = 100
							}
              if(this.turnoverDetails[0].deposit_next !== 0){
                this.showDepo = true
              }
              if(this.turnoverDetails[0].turnover_next !== 0){
                this.showTo = true
              }
            } else {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
            this.loading = false
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
            this.loading = false
          })
        }
    },
		changeTab(option){
			if(option === this.selectedTab){
				return;
			}else{
				this.selectedTab = option
			}
		},
		getBankingMode() {
      if (this.sessionToken) {
				this.startRender = true
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/getBankingMode", { account_id, auth_token })
          .then(response => {
            if (response.success == true) {
              let bankMode = response.data.payment_mode
              bankMode.forEach(y => {
								// this.bankModeList.push(y.payment_mode)
								this.bankModeList.push({
									"payment_mode": y.payment_mode,
									"payment_desc": y.payment_desc
								})
              })
							let paymentChannel = response.data.payment_mode_loop
							paymentChannel.forEach(y => {
								if(y.payment_mode === "gcash"){
									this.gcashChannel.push({
										provider_group: y.provider_group,
										is_recommend: y.is_recommend,
										min_limit: y.min_limit,
										max_limit: y.max_limit
									})
								}
								if(y.payment_mode === "gcashqr"){
									this.gcashqrChannel.push({
										provider_group: y.provider_group,
										is_recommend: y.is_recommend,
										min_limit: y.min_limit,
										max_limit: y.max_limit
									})
								}
								if(y.payment_mode === "maya"){
									this.mayaChannel.push({
										provider_group: y.provider_group,
										is_recommend: y.is_recommend,
										min_limit: y.min_limit,
										max_limit: y.max_limit
									})
								}
								if(y.payment_mode === "grabpay"){
									this.grabChannel.push({
										provider_group: y.provider_group,
										is_recommend: y.is_recommend,
										min_limit: y.min_limit,
										max_limit: y.max_limit
									})
								}
								if(y.payment_mode === "usdt"){
									this.usdtChannel.push({
										provider_group: y.provider_group,
										is_recommend: y.is_recommend,
										min_limit: y.min_limit,
										max_limit: y.max_limit
									})
								}
								if(y.payment_mode === "bank"){
									this.bankChannel.push({
										provider_group: y.provider_group,
										is_recommend: y.is_recommend,
										min_limit: y.min_limit,
										max_limit: y.max_limit
									})
								}
								if(y.payment_mode === "qrph"){
									this.qrphChannel.push({
										provider_group: y.provider_group,
										is_recommend: y.is_recommend,
										min_limit: y.min_limit,
										max_limit: y.max_limit
									})
								}
              })
							
							if(this.bankModeList.length > 0){
								if(this.bankModeList[0].payment_mode === 'gcash'){
									this.selectedTab = 0
								}
								if(this.bankModeList[0].payment_mode === 'gcashqr'){
									this.selectedTab= 1
								}
								if(this.bankModeList[0].payment_mode === 'maya'){
									this.selectedTab= 2
								}
								if(this.bankModeList[0].payment_mode === 'grabpay'){
									this.selectedTab= 3
								}
								if(this.bankModeList[0].payment_mode === 'usdt'){
									this.selectedTab= 4
								}
								if(this.bankModeList[0].payment_mode === 'bank'){
									this.selectedTab= 5
								}
								if(this.bankModeList[0].payment_mode === 'qrph'){
									this.selectedTab= 6
								}
							}
							
              // if(this.bankModeList.includes('MANUAL')){
              //   this.selectedTab= 4
              // }else{
							// 	if(this.bankModeList.includes('gcash')){
							// 		this.selectedTab= 0
							// 	}else{
							// 		if(this.bankModeList.includes('gcashqr')){
							// 			this.selectedTab= 1
							// 		}else{
							// 			if(this.bankModeList.includes('maya')){
							// 				this.selectedTab= 2
							// 			}else{
							// 				// if(this.bankModeList.includes('RMPAY')){
							// 				// 	this.selectedTab= 3
							// 				// }	
							// 			}                   
							// 		} 
							// 	}
                                
              // }             
              this.minDeposit = (response.data.min_setting.filter(item => item.setting_key === "min_deposit"))[0].setting_value
              this.operatorBankList = response.data.operator_deposit_bank_list
              this.promoList = response.data.promotion_list
              // this.promoList.sort((a, b) => (a.promo_id > b.promo_id) ? 1 : (a.promo_id === b.promo_id) ? ((a.package_amount > b.package_amount) ? 1 : -1) : -1 )
							this.promoList.sort((a, b) => (a.promo_id > b.promo_id) ? 1 : ((b.promo_id > a.promo_id) ? ((a.package_amount > b.package_amount) ? 1 : -1) : 0))
							
            } else {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
							
            }
						this.startRender = false
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
						this.startRender = false
          });
      }
    }
	}
}
</script>
<style lang="scss" scoped>
.duo-display{
	width: 50% !important;
}
.trio-display{
  width: 33.33% !important
}
.quad-display{
  width: 25% !important
}
.pent-display{
  width: 20% !important
}
.hex-display{
  width: 16.66% !important
}
.hepta-display{
	width: 14.2857% !important
}
.deposit-container{
	border-right: 1px solid #5C4180;
}
.withdrawal-container{
	color: inherit;
  text-decoration: inherit;
}
button{
	height: 100%;
}
.payment-mode .slick-prev:before, .payment-mode .slick-next:before { font-family: FontAwesome; font-size: 38px; line-height: 1; -webkit-font-smoothing: antialiased; -moz-osx-font-smoothing: grayscale; }   
.payment-mode .slick-prev, .payment-mode .slick-next {top:40%;}
.payment-mode .slick-prev.slick-disabled:before, .payment-mode .slick-next.slick-disabled:before { opacity:0;}
.payment-mode .slick-prev:before { content: "\f053"; }
.payment-mode .slick-next:before { content: "\f054"; }

.resbox-tabs .nav-tabs {
	// background-color: #33244a;
	// color: #ffffff;
	// flex-wrap: nowrap;
	// border-bottom: 1px solid #7a18a5;
	// display: flex;
	flex-wrap: wrap;
}
.resbox-tabs .nav-tabs .nav-item {
	width: 25%;
	@media(min-width: 681px ){
		width: 16.66%;
	}
	@media(min-width: 1081px){
		width: 14.285%;
	}
}
.resbox-tabs .nav-tabs .nav-item.show .nav-link, .resbox-tabs .nav-tabs .nav-link.active {
	background-color: #8901ff;
	color: #ffffff;
	filter: grayscale(0);
}
.resbox-tabs .nav-tabs .nav-link {
	border: 0;
	border-radius: 0;
	width: 100%;
	text-align: center;
	text-transform: uppercase;
	// color: #ffffff;
	font-weight: bold;
	margin: 0;
	padding: 8px 0;
	filter: grayscale(1);
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
}
.resbox-tabs .nav-tabs .nav-link img {
	max-width: 48px;
	margin-bottom: 2px;
}
.resbox-tabs .nav-tabs .nav-link span {
	font-size: 12px;
}
.resbox-tabs .tab-content{
	@media(max-width: 680px) {
		padding: 0 !important
	}
}
</style>